<template>
    <div class="modal fade modal-upload" id="preInputCopyModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal body -->
                <div class="modal-body">
                    <div class="center-modal">

                        <div class="center-ttl font300 d-flex justify-content-center">
                            {{ $t('voucher.modal-preInputCopy.message') }}
                        </div>

                        <div class="row mt-4 no-gutters g-btn-select">
                            <div class="col-6 pr-2">
                                <button
                                    class="btn btn-pink-53 fs-18 w-100"
                                    data-toggle="modal"
                                    @click="setVoucher"
                                >{{$t('button.ok')}}</button>
                            </div>

                            <div class="col-6 pl-2">
                                <button class="btn btn-gray-53 fs-18 w-100" data-dismiss="modal">{{$t('button.cancel')}}</button>
                            </div>
                        </div>

                        <div class="pre-input mt-4 pb-2">
                            <div class="row no-gutters mt-2" v-for="(preInput, index) in preInputList" :key="index">
                                <div class="col-4 pl-3">
                                    {{preInput.label}}
                                </div>
                                <div class="col-8 pl-2">
                                    {{preInput.value}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';
import StorageService from "@/services/common/storage.service";

export default {
  name: "PreInputCopy",
  data() {
    return {
      preInputList: [],
    };
  },
  methods: {
    setVoucher() {
      this.$emit("setVoucher");
    },
    setPreInputList() {
      const voucher = JSON.parse(StorageService.getPreInputVoucher());
      const template_1 = [
        "transactionDate",
        "use",
        "accountName",
        "city",
        "totalAmount",
        "type",
        "taxRate",
      ];
      const template_5 = ["transactionDate"];
      const template_9 = [
        "transactionDate",
        "use",
        "accountName",
        "city",
        "totalAmount",
        "type",
        "taxRate",
      ];

      let fields = [];
      switch (Utils.getTemplateId(voucher.voucherTypeId)) {
        case 1:
          fields = template_1;
          break;
        case 5:
          fields = template_5;
          break;
        case 9:
          fields = template_9;
          break;
      }

      let preInputList = [];
      fields.forEach((field) => {
        let preInput = { label: "", value: "" };
        switch (field) {
          case "transactionDate":
            preInput.label = this.$t("voucher.general.transaction_date");
            let transactionDate = new Date(voucher.transactionDate);
            if (!Utils.isEmptyStr(transactionDate)) {
                transactionDate.setHours(transactionDate.getHours() + 9);
                preInput.value = DateUtils.formatDateYYYYMMDD(transactionDate);
            } else {
                preInput.value = "";
            }
            break;
          case "use":
            preInput.label = this.$t("voucher.general.use");
            preInput.value = voucher.use ? voucher.use : "";
            break;
          case "city":
            if (voucher.tourDomestic) break;
            preInput.label = this.$t("voucher.general.city");
            preInput.value = voucher.use ? voucher.city : "";
            break;
          case "accountName":
            preInput.label = this.$t("voucher.general.account_name");
            preInput.value = voucher.use ? voucher.accountName : "";
            break;
          case "totalAmount":
            preInput.label = this.$t("voucher.general.amount");
            const totalAmount = Utils.formatPrice(
              voucher.totalAmount,
              voucher.currencyId
            );
            const currencyName = Utils.getCurrencyName(voucher.currencyId);
            preInput.value = totalAmount ? totalAmount + currencyName : "0" + currencyName;
            break;
          case "type":
            preInput.label = this.$t("voucher.general.category");
            preInput.value = Utils.getInOutType(voucher.type);
            break;
          case "taxRate":
            preInput.label = this.$t("voucher.general.tax_rate");
            preInput.value = Utils.getTaxRate(voucher.taxRate);
            break;
        }
        if (preInput.label) {
          preInputList.push(preInput);
        }
      });

      this.preInputList = preInputList;
    },
  },
};
</script>

<style scoped>
.pre-input {
  border: 2px dotted #999999;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/PreInputCopy.vue